import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=ae8251e4&"
import script from "./ExamResult.vue?vue&type=script&lang=ts&"
export * from "./ExamResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports